import { z } from 'zod';

import { type LoginRequest, type LoginResponse } from './login.dto.js';
import { UserAuthTokensResponseSchema } from './session.schema.js';

export const LoginRequestSchema: z.ZodType<LoginRequest> = z.object({
  email: z.string().trim().pipe(z.email()),
  password: z.string().min(1),
});

export const LoginResponseSchema: z.ZodType<LoginResponse> = UserAuthTokensResponseSchema;
